// TODO - Change url for respective environment
const cmsConfig = {
  baseUrl: process.env.REACT_APP_CMS_CONFIG_URL,
};

export default cmsConfig;
